import styled from 'astroturf/react';
import Svg from 'src/components/Svg';
import Button from 'src/components/Button';
import TextField from 'src/components/TextField';



const CheckBoxContainer = styled('div')`
    & div[class*='Checkbox'] {
        display: flex;
        padding-left: 45px;
    }
    & span[class*='checkbox__label'] {
        font-family: var(--ph-font-family-source-sans-pro) !important;
        font-size: var(--ph-text-xs) !important;
        color: var(--dark-blue) !important;
    }
`;

const RequiredFieldLabel = styled('label')`
  font-family: var(--ph-font-family-source-sans-pro);
  font-size: var(--ph-text-xs);
  color: var(--dark-blue);

  &:before {
    content: ' ';
    display: inline-block;
    height: 6px;
    width: 6px;
    margin-right: 5px;
    clip-path: circle(2px at center);
    background-color: var(--cyan-green);
  }
`;

const FormError = styled('div')`
  min-height: 20px;
`;

const ShowButton = styled(Button)`
    color: var(--dark-blue) !important;
    font-size: var(--ph-text-xs) !important;
    font-family: var(--ph-font-family-source-sans-pro) !important;
    top: 21px !important;

    &:hover{
        text-decoration: underline;
    }
`;

const TextFieldRequiredWrapper = styled(TextField)`
    font-family: var(--ph-font-family-source-sans-pro);
    font-size: var(--ph-text-sm);

    & input[class*='TextField'] {
        border: 1px solid #bebfc1;
        height: 35px;
    }

    & input[class*='TextField']::placeholder {
        color: #bebfc1;
        opacity: 1;
    }

    & div[class*='textFieldLabel'] {
        min-width: 0px;

        &:after {
            content: " * ";
            color: var(--ph-red-500);
            margin-left: 3px;
        }
    }

`;

const TextFieldError = styled('h4')`
  font-family: var(--ph-font-family-source-sans-pro);
  font-size: var(--ph-text-sm);
  color: var(--ph-red-500);
  text-align: center;
  pointer-events: none;
  text-transform: initial;
`;

export default {
    CheckBoxContainer,
    ShowButton,
    TextFieldRequiredWrapper,
    TextFieldError,
    RequiredFieldLabel,
    FormError
};
